import { observer } from "mobx-react-lite";
import { Navigate } from "react-router-dom";
import { appStore } from "../../Store/appStore";
import GuardantUsbChecker from "../../guardant/GuardantUsbChecker";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: JSX.Element;
};

const checkGuardantConnection = async (): Promise<boolean> => {
  try {
    console.log("ProtectedRoute.tsx");
    // let guardantChecker = new GuardantUsbChecker(123);
    // const isConnected = await guardantChecker.checkConnect();
    // return isConnected;
    return true;
  } catch (error) {
    console.error('Error checking Guardant USB connection:', error);
    return false;
  }
};

const ProtectedRoute = ({ authenticationPath, outlet }: ProtectedRouteProps): React.ReactElement => {
  const { userStore } = appStore;
  const shouldNavigate = userStore.checkToken();
  
  const checkGuardant = async () => {
    // let isConnected = await checkGuardantConnection();
    // if(!isConnected) userStore.logout();
    //return await isConnected;
    return true;
  };

  return !shouldNavigate || !(checkGuardant()) ? (
    <Navigate to={authenticationPath} />
  ) : (
    outlet
  );
};

export default observer(ProtectedRoute);